import { render, staticRenderFns } from "./ProductionOrderList.vue?vue&type=template&id=966325e4"
import script from "./ProductionOrderList.vue?vue&type=script&lang=js"
export * from "./ProductionOrderList.vue?vue&type=script&lang=js"
import style0 from "./ProductionOrderList.vue?vue&type=style&index=0&id=966325e4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports